import React from 'react';
import styles from './Footer.module.css';
import CompanyLogo from 'Utils/Assets/SVGs/CompanyLogo';
import Facebook from 'Utils/Assets/SVGs/Facebook';
import Instagram from 'Utils/Assets/SVGs/Instagram';
import LinkedIn from 'Utils/Assets/SVGs/LinkedIn';
import YouTube from 'Utils/Assets/SVGs/Youtube';

const Footer = () => {
  return (
    <footer className={styles.footerWrapper} role="contentinfo" data-testid="footer">
      <div className={styles.footerCard} data-testid="footer-card">
        <div className={styles.footerGrid} data-testid="footer-grid">
          <div className={styles.footerBrandCol} data-testid="footer-brand">
            <div className={styles.footerBrandRow}>
              <span className={styles.footerBrandBadge}>
                <CompanyLogo className={styles.footerLogo} data-testid="footer-logo" />
              </span>
              <span className={styles.footerBrandName} data-testid="footer-brand-name">
                Chimera Tech
              </span>
            </div>
            <p className={styles.footerBlurb} data-testid="footer-blurb">
              Innovating reliable automation and integration — shaping the future of connected
              living and industries
            </p>
          </div>

          <div className={styles.footerCol} data-testid="footer-company">
            <h4 className={styles.footerHeading}>Company</h4>
            <ul className={styles.footerList}>
              <li>
                <a className={styles.footerLink} href="/about" data-testid="footer-link-about">
                  About Us
                </a>
              </li>
              <li>
                <a className={styles.footerLink} href="/contact" data-testid="footer-link-contact">
                  Contact Us
                </a>
              </li>
              <li>
                <a className={styles.footerLink} href="/products" data-testid="footer-link-shop">
                  Shop
                </a>
              </li>
            </ul>
          </div>

          {/* <div className={styles.footerCol} data-testid="footer-solutions">
                        <h4 className={styles.footerHeading}>Solutions</h4>
                        <ul className={styles.footerList}>
                            <li><a className={styles.footerLink} href="/solutions/home-industrial" data-testid="footer-link-home-industrial">Home &amp; Industrial Automation</a></li>
                            <li><a className={styles.footerLink} href="/solutions/lab-integration" data-testid="footer-link-lab-integration">Lab Machine Integration</a></li>
                        </ul>
                    </div> */}

          <div className={styles.footerCol} data-testid="footer-cooperation">
            <h4 className={styles.footerHeading}>Cooperation</h4>
            <ul className={styles.footerList}>
              <li>
                <a
                  className={styles.footerLink}
                  href="/about#vision"
                  data-testid="footer-link-vision"
                >
                  Our Vision
                </a>
              </li>
              {/* <li><a className={styles.footerLink} href="/partners" data-testid="footer-link-partners">Become a Partner</a></li>
                            <li><a className={styles.footerLink} href="/reseller" data-testid="footer-link-reseller">Reseller Program</a></li> */}
            </ul>
          </div>

          <div
            className={`${styles.footerCol} ${styles.footerFollowCol}`}
            data-testid="footer-follow"
          >
            <h4 className={styles.footerHeading}>Follow Us</h4>
            <nav aria-label="Social media" className={styles.footerSocial}>
              {/* Facebook */}
                          
              <a
                href="https://www.facebook.com/people/Chimeratechlb/61588282265648/"
                aria-label="Facebook"
                className={styles.footerSocialPill}
                data-testid="footer-social-facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook className={styles.footerIcon} />
              </a>
            

              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/company/chimera-technology/"
                aria-label="LinkedIn"
                className={styles.footerSocialPill}
                data-testid="footer-social-linkedin"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedIn className={styles.footerIcon} />
              </a>

              {/* Instagram */}
                          
              <a
                href="https://www.instagram.com/chimeratech.lb/"
                aria-label="Instagram"
                className={styles.footerSocialPill}
                data-testid="footer-social-instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram className={styles.footerIcon} />
              </a>
            

              {/* YouTube */}
                          
              <a
                href="https://www.youtube.com/channel/UC_BruXkTa-UR708z_iJnLEQ"
                aria-label="YouTube"
                className={styles.footerSocialPill}
                data-testid="footer-social-youtube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <YouTube className={styles.footerIcon} />
              </a>
            
            </nav>
          </div>
        </div>

        <div className={styles.footerDivider} data-testid="footer-divider" />

        <div className={styles.footerLegal} data-testid="footer-legal">
          All rights reserved Chimera Tech {new Date().getFullYear()} &copy;
        </div>
      </div>
    </footer>
  );
};

export default Footer;
